// @ utilities
const { APIPost, APIGet } = require('utilities/APIRequestHelper');
const DateHelper = require('utilities/dateHelper');
const moment = require('moment');
const { formatText } = require('core/i18n').i18n;
const { cloneDeep } = require('lodash');

//commons
const signaturePatternActions = require('actions/signaturePattern');

// @ constants
const {
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_SET_VISIBLE_STEP,
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_VALIDATE_STEP,
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_WILL_CANCEL,
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_RESET_STEP,
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_CLEAR,
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_SET_APPRAISAL_REQUEST,
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_SET_APPRAISAL_SUCCESS,
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_SET_APPRAISAL_FAILURE,
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_GET_APPRAISAL_REQUEST,
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_GET_APPRAISAL_SUCCESS,
    MORTGAGE_REQUEST_APPRAISAL_REQUEST_GET_APPRAISAL_FAILURE,
    MORTGAGE_REQUEST_APPRAISER_VISIT_UPDATE_VISIT_DATE,
    MORTGAGE_REQUEST_APPRAISER_VISIT_UPDATE_ATTEND_OPTION,
    MORTGAGE_REQUEST_APPRAISER_VISIT_UPDATE_APPRAISAL_DATE,
    MORTGAGE_REQUEST_APPRAISER_VISIT_UPDATE_SCHEDULE_OPTION,
    MORTGAGE_REQUEST_FETCH_APPRAISER_REQUEST_SET_ACCOUNT,
    MORTGAGE_REQUEST_FETCH_APPRAISER_REQUEST_SET_TOTAL_COST
} = require('constants/actionTypes');

const { ATTEND, SELECT_DATE } = require('constants/mortgageRequestAppraisalRequest').APPRAISER_VISIT_OPTIONS;
const { SECOND_STEP, DATE_FORMAT_API, EURO_TEXT, CHARGE_ACCOUNT_PREFIX } = require('constants/index');
const {
    PAYMENT_TYPE,
    TRANSFER_TYPE,
    TRANSFER_COUNTRY,
    RECIPIENT_INDICATOR,
    BENEFICIARY_BANK_NAME,
    BENEFICIARY_INDICATOR,
} = require('constants/transferData').TRANSFER_INFORMATION;

const setAccountAction = (accountId, accountBalance, accountIBAN) => ({
    type: MORTGAGE_REQUEST_FETCH_APPRAISER_REQUEST_SET_ACCOUNT,
    data: {
        accountId,
        accountBalance,
        accountIBAN
    }
});

const setTotalCost = data => ({
    type: MORTGAGE_REQUEST_FETCH_APPRAISER_REQUEST_SET_TOTAL_COST,
    data
});

const setVisibleStep = step => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_SET_VISIBLE_STEP,
    data: {
        step
    }
});

const validateWithUI = step => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_VALIDATE_STEP,
    data: {
        step
    }
});

const setWillCancel = willCancel => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_WILL_CANCEL,
    data: {
        willCancel
    }
});

const resetStep = step => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_RESET_STEP,
    data: {
        step
    }
});

const clearRequest = () => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_CLEAR
});

const setAppraisalRequest = () => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_SET_APPRAISAL_REQUEST
});

const setAppraisalSuccess = () => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_SET_APPRAISAL_SUCCESS
});

const setAppraisalFailure = () => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_SET_APPRAISAL_FAILURE
});

const updateAppraiserVisitDate = data => ({
    type: MORTGAGE_REQUEST_APPRAISER_VISIT_UPDATE_VISIT_DATE,
    data
});

const updateAttendOption = data => ({
    type: MORTGAGE_REQUEST_APPRAISER_VISIT_UPDATE_ATTEND_OPTION,
    data
});

const updateAppraisalDate = data => ({
    type: MORTGAGE_REQUEST_APPRAISER_VISIT_UPDATE_APPRAISAL_DATE,
    data
});

const updateScheduleOption = data => ({
    type: MORTGAGE_REQUEST_APPRAISER_VISIT_UPDATE_SCHEDULE_OPTION,
    data
});

const getAppraisalVisitRequest = () => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_GET_APPRAISAL_REQUEST
});

const getAppraisalVisitSuccess = data => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_GET_APPRAISAL_SUCCESS,
    data
});

const getAppraisalVisitFailure = error => ({
    type: MORTGAGE_REQUEST_APPRAISAL_REQUEST_GET_APPRAISAL_FAILURE,
    data: {
        error
    }
});

const postAppraisalVisit = () => (dispatch, getState) => {
    const appraiserVisitState = getState().mortgageRequestAppraisalRequest.getIn(['steps', SECOND_STEP, 'appraiserVisitData']);
    const appraisalVisit = appraiserVisitState.get('selectAttendVisit') === ATTEND;
    const appraisalVisitSelectDate = appraiserVisitState.get('selectVisitDate') === SELECT_DATE;
    const appraisalVisitDate = appraiserVisitState.get('selectedVisitDate');
    const appraisalVisitFormattedDate = appraisalVisitSelectDate ? DateHelper.buildFormattedDate(appraisalVisitDate, 'YYYY-MM-DD') : null;
    const appraisalScheduleValue = appraiserVisitState.get('scheduleSelectedOption');
    const appraisalSchedule = appraisalScheduleValue ? appraisalScheduleValue : null;
    const endpoint = 'mortgageRequestAppraisalVisit';

    const requestData = {
        query: {
            appraisalVisit,
            appraisalVisitDate: (appraisalVisit && appraisalVisitDate) ? appraisalVisitFormattedDate : null,
            appraisalSchedule
        }
    };

    return APIPost({
        dispatch,
        endpoint,
        params: requestData
    }).then(() =>{
        dispatch(getAppraisalVisit())
    })
};

const validateStep = step => (dispatch, getState) => {
    dispatch(validateWithUI(step));
    const isValidUI = getState().mortgageRequestAppraisalRequest.getIn(['steps', SECOND_STEP, 'validUI'])
    if (isValidUI) {
        dispatch(postAppraisalVisit());
    }
};

const getAppraisalVisit = () => dispatch => {
    dispatch(getAppraisalVisitRequest());

    return APIGet({
        dispatch,
        endpoint: 'mortgageRequestAppraisalVisit'
    })
        .then(response => {
            dispatch(getAppraisalVisitSuccess(response.data));
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getAppraisalVisitFailure(response.error));
            } else {
                throw response;
            }
        })
};

const appraisalVisitPayment = () => (dispatch, getState) => {
    const immAppraisalRequest = getState().mortgageRequestAppraisalRequest.getIn(['steps', SECOND_STEP]);
    const agencyPaymentAccount = getState().mortgageRequestPayment.get('paymentAccount');
    const clientPaymentAccount = immAppraisalRequest.get('accountIBAN');
    const paymentImport = immAppraisalRequest.get('totalCost');
    const paymentDate = moment().format(DATE_FORMAT_API);

    const endpoint = 'mortgageRequestAppraisalPayment';
    const params = {
        query: {
            agencyPaymentAccount,
            clientPaymentAccount,
            paymentDate,
            paymentImport,
            paymentReference: '',
            paymentType: PAYMENT_TYPE
        }
    };

    return APIPost({
        dispatch,
        endpoint,
        params
    })
        .then(() => {
            dispatch(setAppraisalSuccess());
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(setAppraisalFailure());
            } else {
                throw response;
            }
        });
};

const apprailsalPaymentConfirmation = postParams => dispatch => {
    const query = cloneDeep(postParams);
    const postData = {
        header: {
            version: 2
        },
        query
    };

    return APIPost({
        dispatch,
        endpoint: 'transferConfirmation',
        params: postData
    })
        .then(response => {
            if (!!response.respuesta) {
                dispatch(appraisalVisitPayment());
            } else {
                dispatch(setAppraisalFailure());
            }
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(setAppraisalFailure());
            } else {
                throw response;
            }
        });
}

const postChange = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {

        const accountInformation = getState().accounts;
        const paymentInformation = getState().mortgageRequestPayment;
        const accountId = getState().mortgageRequestAppraisalRequest.getIn(['steps', SECOND_STEP, 'accountId']);
        const account = accountInformation.getIn(['byId', accountId]);
        const contractNumber = account.get('newContractNumber');
        const product = account.get('newProduct');
        const paymentAccount = paymentInformation.get('paymentAccount').replace(/\s/g, '');
        const paymentImport = getState().mortgageRequestAppraisalRequest.getIn(['steps', SECOND_STEP, 'totalCost']);
        const beneficiaryName = formatText("mortgageRequestAppraisalRequest-beneficiaryName");
        const date = moment().format(DATE_FORMAT_API);
        const originAccount = `${CHARGE_ACCOUNT_PREFIX}${product}${contractNumber}`;

        const postData = {
            header: {
                version: 2
            },
            query: {
                contratoOrdenante: {
                    numeroContrato: contractNumber,
                    producto: product
                },
                cuentaBeneficiario: paymentAccount,
                divisaCtaOrd: EURO_TEXT,
                importe: {
                    divisa: EURO_TEXT,
                    importe: paymentImport
                },
                fechaEmision: date,
                indicadorResidenciaDestinatario: RECIPIENT_INDICATOR,
                nombreCompletoBeneficiario: beneficiaryName,
                tipoTransferencia: TRANSFER_TYPE,
                paisTransferencia: TRANSFER_COUNTRY,
                contratoOrdenanteIban: originAccount
            }
        };

        dispatch(setAppraisalRequest());

        return APIPost({
            dispatch,
            endpoint: 'transferValidation',
            params: postData
        })
            .then(response => {
                const { tipoSepa, actuanteBeneficiario } = response;
                const params = cloneDeep(postData.query);

                const {
                    contratoOrdenante,
                    cuentaBeneficiario: cuentaIbanBeneficiario,
                    fechaEmision,
                    importe,
                    nombreCompletoBeneficiario,
                    tipoTransferencia
                } = params;

                const appraisalPaymentData = {
                    tipoSepa,
                    actuanteBeneficiario,
                    contratoOrdenante: {
                        numerodecontrato: contratoOrdenante.numeroContrato,
                        producto: contratoOrdenante.producto
                    },
                    cuentaIbanBeneficiario,
                    dataToken,
                    fechaEmision,
                    importe,
                    indResidenteBeneficiario: BENEFICIARY_INDICATOR,
                    nombreBancoIbanBeneficiario: BENEFICIARY_BANK_NAME,
                    nombreCompletoBeneficiario,
                    tipoTransferencia
                }

                dispatch(apprailsalPaymentConfirmation(appraisalPaymentData));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(setAppraisalFailure());
                } else {
                    throw response;
                }
            });
    };

    new Promise(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback)
    });
};

const setAccount = (accountId, accountBalance, accountIBAN) => dispatch => {
    dispatch(setAccountAction(accountId, accountBalance, accountIBAN))
};

module.exports = {
    updateAppraiserVisitDate,
    updateAttendOption,
    updateAppraisalDate,
    updateScheduleOption,
    getAppraisalVisit,
    postAppraisalVisit,
    validateStep,
    setVisibleStep,
    setWillCancel,
    resetStep,
    clearRequest,
    postChange,
    setAccount,
    setTotalCost
};
